import { Attribute, BelongsTo, JsonApiModel, JsonApiModelConfig } from 'angular2-jsonapi'
import { ArrayConverter } from '../../core/converters/array.converter'
import { AgrupamentoConverter } from '../converters/agrupamento.converter'
import { EmpresaQueVendeComCartoes } from '../empresa-que-vende-com-cartoes.model'
import { Agrupamento } from './agrupamento.model'
import { Extrato } from './extrato.interface'
import { Venda } from './venda.model'

@JsonApiModelConfig({
    type: 'extratos-de-vendas'
})
export class ExtratoDeVendas extends JsonApiModel implements Extrato<Venda> {
    @Attribute() inicio: Date
    @Attribute() fim: Date
    @Attribute() idDaEmpresa: number
    @Attribute() agrupador: number
    @Attribute({
        converter: new ArrayConverter(new AgrupamentoConverter(Venda))
    })
    agrupamentos: Agrupamento<Venda>[]

    @BelongsTo() empresaQueVendeComCartoes: EmpresaQueVendeComCartoes
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/extrato/extrato-de-vendas.model.ts